import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
} from "react-icons/io";
import avatar from "assets/img/avatars/user.png";
import { connect } from "react-redux";
import { logoutRequest, logoutAsUser } from "../../redux/auth/authState";
import Breadcrumbs from "components/breadcrumbs";
import ToggleCollapse from "components/sidebar/components/ToggleCollapse";
import CopilotEli from "components/ai/CopilotEli";
import { useCRUDAccess } from "utils/useCRUDAccess";
import { MODULE_AI_COPILOT, MY_ACTAS_USR } from "variables/modules";
import ButtonWithConfirm from "components/button/buttonwithconfirm";



const Navbar = ({...props}) => {
	//const { logout, state } = useContext(AuthContext);
  const { onOpenSidenav } = props;
  const [darkmode, setDarkmode] = React.useState(
    localStorage.getItem("theme") === "dark"
  );

  const dispatch = useDispatch();

  const isImpersonating = useSelector((state) => state.auth.isImpersonating);

  React.useEffect(() => {
    if (darkmode) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkmode]);

  const user = useSelector((state) => state.auth.user);
  const checkCRUDAccess = useCRUDAccess();

  const handleLogout = (e) => {
	  e.preventDefault();
    isImpersonating == 1 ? dispatch(logoutAsUser()) : dispatch(logoutRequest());
  };

  const handleStopImpersonating = (e) => {
    dispatch(logoutAsUser());
  }

  return (
    <nav className="frosted-glass px-3 sm:px-6 py-3 sm:py-4 sticky top-0 z-40 flex flex-row flex-wrap items-center justify-between p-2 shadow border-emerald-100/50">
      
      <div className="flex flex-row">
        <div className="hidden xl:flex items-center">
            <ToggleCollapse/>
        </div>
        <Breadcrumbs />
      </div>

      {isImpersonating == 1 && 
        <div className="flex justify-center px-4">
          <ButtonWithConfirm 
            className="btn btn-primary btn-small rounded-full"
            confirmHandler={handleStopImpersonating}
            confirmationMessage="Are you sure you want to stop impersonating?"
          >
            Stop Impersonating {user.name}
          </ButtonWithConfirm>
        </div>
      }
      
      <div className="relative mt-[3px] flex h-[61px] w-[155px] flex-grow items-center justify-around gap-2 rounded-full px-2 py-2 md:w-[165px] md:flex-grow-0 md:gap-1 xl:w-[165px] xl:gap-2">
        <div className="hidden flex h-full items-center rounded-full bg-lightPrimary text-theme-700 dark:bg-intsamis-900 dark:text-white xl:w-[425px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-theme-700 outline-none placeholder:!text-gray-400 dark:bg-intsamis-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-700 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* {checkCRUDAccess(MODULE_AI_COPILOT, 'view') && <CopilotEli/> } */}
        {/* start Notification */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-700 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-intsamis-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-theme-700 dark:text-white">
                  Notification
                </p>
                <p className="text-sm font-bold text-theme-700 dark:text-white">
                  Mark all read
                </p>
              </div>

              {/*<button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New Update: Horizon UI Dashboard PRO
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new update for your downloaded item is available!
                  </p>
                </div>
              </button>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New Update: Horizon UI Dashboard PRO
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new update for your downloaded item is available!
                  </p>
                </div>
              </button>*/}
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />       
        <div
          className="cursor-pointer text-gray-700"
          onClick={() => setDarkmode(!darkmode)}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-700 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-700 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={avatar}
              alt="Elon Musk"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-intsamis-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-theme-700 dark:text-white">
                    👋 Hey, {user?.name}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                {(user?.user_level === 5 || user?.user_level === 4) &&
                  <a
                    href="/console/profiles"
                    className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                  >
                    My Profile
                  </a>
                } 
                {checkCRUDAccess(MY_ACTAS_USR, 'view') && 
                  <a
                    href="/console/act-as-user"
                    className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                  >
                    Act As User
                  </a>
                }
                
                <a
                  href=" "
                  className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
                  onClick={handleLogout}
                >
                  Log Out
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
